<script>
export default {
  name: 'Login',
  created () {
    window.location.href = process.env.VUE_APP_IPCHAIN_LOGIN_URL
  }
}
</script>
